import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { CssBaseline, CircularProgress, Container, Button, Grid, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, CardHeader, Box, darken, InputAdornment } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import CustomizedSnackbars from '../../components/material-snackbars';
import Api from '../../services/api';
import MyMaterialTable from '../../components/table';
import { Can } from '../../config/ability-context'
import { AbilityContext } from '../../config/ability-context'
import { FormattedMessage, injectIntl } from 'react-intl';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Pagination from '@mui/material/Pagination';
import Search from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import SimpleSelect from '../../components/select/simple-search';
import ClearIcon from '@mui/icons-material/Clear';
import Chip from '@mui/material/Chip';
import * as componentActions from '../../redux/actions/knowledgebases';
import * as articleActions from '../../redux/actions/articles';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import './style.css';
import DescriptionIcon from '@mui/icons-material/Description';
import ReactHtmlParser from 'react-html-parser';
import ImageList from '@mui/material/ImageList';
import { AttachFile } from '@mui/icons-material';
import Badge from '@mui/material/Badge';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import moment from 'moment';
import { browserHistory } from "../../helpers/history";
import FileCopyIcon from '@mui/icons-material/FileCopy';
//import ReactHtmlParser from 'react-html-parser';
import * as FileService from '../../services/attachment.service';
import { PapiroConsole } from 'src/utils/papiroConsole';
import Header from 'src/components/header-external';
import Modal from 'src/components/modal-external/modal-principal';
import Footer from 'src/components/footer-external';
import LogoMarca from 'src/images/new-logo2-cmtech.png'

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

const StyledTextField = styled(TextField)({
    backgroundColor: "#fff",
    borderRadius: "12px",
    "& .MuiOutlinedInput-root": {
        borderRadius: "12px",
        "& fieldset": {
            border: "1px solid #e5e7eb",
        },
        "&:hover fieldset": {
            border: "1px solid #d1d5db",
        },
        "&.Mui-focused fieldset": {
            border: "2px solid #6366f1",
        },
    },
    "& .MuiInputBase-input": {
        padding: "12px 16px",
        fontSize: "0.95rem",
    },
})


class ExternalKnowledgeBases extends Component {

    constructor(props) {
        super(props);

        let filters = [
            { name: "Palavras-Chaves", id: "keyword" },
            { name: "Titulo", id: "title" },
            /*{ name: "Autor", id: "createduser" },
            { name: "Patrimônios", id: "patrimony" },
            { name: "Descrição", id: "description" },
            */
        ];

        this.initialKnowledgeBaseItem = {
            id: 0,
            title: '',
            description: '',
            knowledgebasepatrimonies: [],
            knowledgebaseattachments: [],
            knowledgebasekeywords: [],
        }

        this.initialEvaluation = {
            id: 0,
            knowledgebaseid: 0,
            wasuseful: null,
            description: '',
            createdat: moment().format('YYYY/MM/DD HH:mm:ss'),
            updatedat: moment().format('YYYY/MM/DD HH:mm:ss'),
        }

        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            resultList: [],
            contentFilter: '',
            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            count: 0,
            hirerId: 0,
            searchValue: '',
            filterSelected: 0,
            filters: filters,
            knowledgeBaseDetailsDialogOpen: false,
            knowledgeBaseItem: this.initialKnowledgeBaseItem,
            evaluation: this.initialEvaluation,
            clientportal: {},
            createCalledDialogOpen: false,
            calledServiceSettingsList: [],
            logoimagesrc: '',
            appName: Api != null ? Api.getAppName() : "CMTECH - Mexx 2DO",
            searchValueBar: "",
        };

        this.isClient = true;

        this.closeNotification = this.closeNotification.bind(this);
        this.callSearch = this.callSearch.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.changeValues = this.changeValues.bind(this);
        this.addFilter = this.addFilter.bind(this);
        this.knowledgeBaseDetails = this.knowledgeBaseDetails.bind(this);
        this.getHirerId = this.getHirerId.bind(this)
        localStorage.setItem('newFilter', '');
        localStorage.setItem('newSearch', '');
    }

    async changeValues(stateName, value, text = '') {
        this.setState({ filterSelected: value });
    }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value

        this.setState({
            [name]: value,
        })
    }

    onChangePaginate = (e, page) => {
        this.setState({ page: page });
        this.getItens(page);
    }

    knowledgeBaseDetailsClose = _ => this.setState({ knowledgeBaseDetailsDialogOpen: false, knowledgeBaseItem: this.initialKnowledgeBaseItem, evaluation: this.initialEvaluation })

    knowledgeBaseDetails = async (item) => {
        this.setState({ loading: true })

        this.setState({ loading: false, knowledgeBaseDetailsDialogOpen: true, knowledgeBaseItem: item })
    }

    handleEvaluationDescription = (val) => {
        this.setState(prevState => ({
            evaluation: {
                ...prevState.evaluation,
                description: val
            }
        }))
    }

    searchArticle = () => {
        this.props.addCurrentSearch(this.state.searchValueBar, "text")
        this.props.history.push(`/${this.props.match.params.lang}/article-list-external`)
    }


    setPagination(count, page) {

        let totalPage = Math.ceil(count / 10);
        this.setState({ totalPages: totalPage })
        if (count > 0) {
            if (page == 1) {
                if (count < 10) {
                    this.setState({ pageStart: 1, pageEnd: count });
                } else {
                    this.setState({ pageStart: 1, pageEnd: 10 });
                }
            } else {
                let pageStart = ((page - 1) * 10) + 1;
                if (count >= page * 10) {
                    this.setState({ pageStart: pageStart, pageEnd: page * 10 });
                } else {
                    this.setState({ pageStart: pageStart, pageEnd: count });
                }
            }
        } else {
            this.setState({ totalPages: 0, page: 1, count: 0 });
        }

    }

    async addFilter() {
        const intl = this.props.intl;
        if (this.state.searchValue.trim() == '' && this.state.filterSelected == 0) {
            this.setState({
                openNotification: true, notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "caled.list.notification.select.one.filter.option" })
            });
        } else {
            let newFilter = localStorage.getItem('newFilter');
            let newSearch = localStorage.getItem('newSearch');

            if (this.state.searchValue != '' && this.state.filterSelected != 0) {

                if (this.state.filterSelected === "open") {
                    let date = this.state.searchValue.split("/");
                    if (date.length === 3) {
                        date = `${date[2]}-${date[1]}-${date[0]}`
                    }

                    newFilter += this.state.filterSelected + "@";
                    newSearch += date + "@";

                    let nameField;
                    for (let i = 0; i < this.state.filters.length; i++) {

                        if (this.state.filters[i].id === this.state.filterSelected) {
                            nameField = this.state.filters[i].name;
                        }
                    }

                    this.setState({
                        contentFilter: this.state.contentFilter + nameField + ": " + this.state.searchValue + "\n"
                    });

                } else {

                    newFilter += this.state.filterSelected + "@";
                    newSearch += this.state.searchValue + "@";

                    let nameField;
                    for (let i = 0; i < this.state.filters.length; i++) {
                        if (this.state.filters[i].id === this.state.filterSelected) {
                            nameField = this.state.filters[i].name;
                        }
                    }

                    this.setState({
                        contentFilter: this.state.contentFilter + nameField + ": " + this.state.searchValue + "\n"
                    });
                }

                localStorage.setItem("newFilter", newFilter);
                localStorage.setItem("newSearch", newSearch);

                this.setState({
                    searchValue: '',
                    filterSelected: 0
                })
            }
        }

        // console.log(this.state.contentFilter);

    }

    onFieldChange(event) {
        this.setState({ [event.target.name]: event.target.value, page: 1 });
    }

    callSearch = async () => {
        if (this.state.searchValue.trim() != '' && this.state.filterSelected != 0) {
            await this.addFilter();
        }
        if (this.state.contentFilter && this.state.contentFilter.length > 0) {
            this.setState({ loading: true });
            await this.getItens(this.state.page);
            this.setState({ loading: false });
        }
        /*if (this.state.filterSelected != 0) {
            this.getItens(this.state.page);
        }*/
    }

    async clearFields() {
        await this.setState({ filterSelected: 0, searchValue: '', page: 1, contentFilter: '' })
        localStorage.setItem('newFilter', '');
        localStorage.setItem('newSearch', '');
        this.getItens(1);
    }

    async componentWillReceiveProps(nextProps) {
        if (nextProps.location && nextProps.location.state === 'reload') {
            await this.componentDidMount();
        }
    }

    async componentDidMount() {
        this.setState({ loading: true })
        document.title = this.state.appName;
        await this.getHirerId()
        if (!this.state.clientportal || !this.state.clientportal.id || !this.state.clientportal.id <= 0) {
            PapiroConsole.log("Sem client portal")
            await this.getClientPortal()
        }
        var generalSearchKnowledgeBase = JSON.parse(localStorage.getItem("generalSearchKnowledgeBase"))
        if (generalSearchKnowledgeBase != null && generalSearchKnowledgeBase.title) {
            this.setState({
                filterSelected: "title",
                searchValue: generalSearchKnowledgeBase.title
            }, () => {
                this.addFilter()
            })
        }
        await this.getItens()
        this.setState({ loading: false })
    }

    getHirerId = async () => {
        await Api.get(`/configs/cancreateclientusersexternal`)
            .then(result => {
                if (result.data.success) {
                    if (result.data.data != null) {
                        if (result.data.data.hirerid != null && result.data.data.hirerid > 0)
                            this.setState({ hirerId: result.data.data.hirerid }
                            )
                        else
                            browserHistory.goBack()
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result);
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);
            });
    }

    getItens = async (page = 1) => {

        let url = `/knowledgebasekeywords/external/paginate/hirer/${this.state.hirerId}?page=${page}`;

        let newFilter = localStorage.getItem('newFilter');
        let newSearch = localStorage.getItem('newSearch');

        if (newFilter != '' && newSearch != '') {
            url += `&search=${newSearch}&field=${newFilter}`;
            this.setState({ dataFilter: true });
        }
        this.setState({ loading: true });
        await Api.get(url)
            .then(result => {
                if (result.data.success) {

                    let count = result.data.count;
                    this.setState({ count: count });
                    this.setPagination(count, page);

                    let defaultExpand = false
                    let generalSearchKnowledgeBase = JSON.parse(localStorage.getItem("generalSearchKnowledgeBase"))
                    localStorage.removeItem("generalSearchKnowledgeBase")

                    const newFormmatedList = result.data.data.map(item => {

                        let knowledgebaseknowledgebases = [];

                        item.knowledgebaseknowledgebases.sort((a, b) => {
                            const hasOrderA = a.order != null && a.order !== 0;
                            const hasOrderB = b.order != null && b.order !== 0;

                            const hasOrderAAndOrderB = hasOrderA && hasOrderB;
                            const isEqualOrderAAndOrderB = hasOrderAAndOrderB && (a.order === b.order);

                            if (hasOrderAAndOrderB && !isEqualOrderAAndOrderB) {
                                return a.order - b.order;
                            }

                            if (hasOrderA && !hasOrderB) return -1;
                            if (!hasOrderA && hasOrderB) return 1;

                            if (a.title && b.title) {
                                return a.title.localeCompare(b.title);
                            }

                            return a.id - b.id;
                        });

                        if (item.knowledgebaseknowledgebases != null) {
                            item.knowledgebaseknowledgebases.map((kbItem, kbIdx) => {

                                let keywords = "";
                                let keyWordsList = [];
                                kbItem.knowledgebaseknowledgebasekeywords.map(linkKb => {
                                    if (linkKb && linkKb.knowledgebasekeyword && linkKb.knowledgebasekeyword.word)
                                        keywords = linkKb.knowledgebasekeyword.word + ", " + keywords;
                                    keyWordsList.push(<div className='kb-key'>{linkKb.knowledgebasekeyword.word}</div>)
                                })
                                keywords = keywords.slice(0, -2);

                                keyWordsList = keyWordsList.sort(function (a, b) {
                                    if (a.title < b.title) { return -1 }
                                    if (a.title > b.title) { return 1 }
                                    return 0
                                })
                                if (kbItem.knowledgebaseknowledgebasekeywords && kbItem.knowledgebaseknowledgebasekeywords.length > 2) {
                                    let keywordsSublist = kbItem.knowledgebaseknowledgebasekeywords.slice(2)
                                    let moreKeyWords =
                                        <HtmlTooltip
                                            interactive
                                            placement="bottom-start"
                                            title={
                                                <React.Fragment className='kb-tooltip-root'>
                                                    <div className='kb-tooltip'>
                                                        {keywordsSublist.map((kItem, key) => { return <div className='kb-key kb-key-tooltip' key={key}>{kItem.knowledgebasekeyword.word}</div> })}
                                                    </div>
                                                </React.Fragment>
                                            }
                                        >
                                            <div className='kb-key'>+{(keyWordsList.length - 2)}</div>
                                        </HtmlTooltip>
                                    keyWordsList.push(moreKeyWords)
                                }
                                knowledgebaseknowledgebases.push(<div className='kb-card' onClick={() => this.knowledgeBaseDetails(kbItem)}>
                                    <div className='kb-card-more'>
                                        <Tooltip title={<h5><FormattedMessage id="details" /></h5>}>
                                            <IconButton color="primary" aria-label="details">
                                                <DescriptionIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                    <div className='kb-card-details'>
                                        <div className='kb-title'>{kbItem.title}</div>
                                        <div className='kb-key-title'>#{kbItem.id}</div>
                                        {(keyWordsList && keyWordsList.length > 0 && keyWordsList.length <= 2) &&
                                            <div className='kb-key-title'>Palavras chave: <div className='kb-keys'>{keyWordsList.map(keyItem => { return keyItem })}</div></div>
                                        }
                                        {(keyWordsList && keyWordsList.length > 2) &&
                                            <div className='kb-key-title'>Palavras chave: <div className='kb-keys'>{keyWordsList.map((keyItem, keyIdx) => {
                                                if (keyIdx < 2 || (keyWordsList.length - 1 === keyIdx)) return keyItem
                                            })}</div></div>
                                        }
                                    </div>
                                </div>)
                                if (generalSearchKnowledgeBase && kbItem.id == generalSearchKnowledgeBase.id) {
                                    defaultExpand = true
                                    this.knowledgeBaseDetails(kbItem)
                                }
                            })
                        }

                        let collapseCardItem = <Accordion style={{ marginTop: "10px" }} defaultExpanded={defaultExpand}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`keyword${item.id}-content`}
                                id={`keyword${item.id}-header`} >
                                <div style={{ display: 'flex' }}>
                                    <Typography style={{ textTransform: 'capitalize', marginRight: 10, fontSize: '1.5em' }}>{item.word}</Typography>
                                    <Badge badgeContent={item.count} color="primary">
                                        <EmojiObjectsIcon />
                                    </Badge>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='material-table'>
                                    {knowledgebaseknowledgebases.map(item => {
                                        return item
                                    })}
                                </div>
                            </AccordionDetails>
                        </Accordion>

                        if (defaultExpand) {
                            defaultExpand = false
                            generalSearchKnowledgeBase = null
                        }

                        return {
                            ...item,
                            collapseCardItem: collapseCardItem
                        }

                    });
                    this.setState({ resultList: newFormmatedList });
                }
                else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result);
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err);

            });
        this.setState({ loading: false });
    };

    async getClientPortal() {
        const intl = this.props.intl

        await Api.get(`/clientportal/external/hirer/${this.state.hirerId}`)
            .then(result => {
                if (result.data && result.data.success) {
                    this.setState({
                        clientportal: result.data.data
                    })
                    if (result.data.data.logoimage) {
                        PapiroConsole.log('result.data.data.logoimage')
                        PapiroConsole.log(result.data.data.logoimage)
                        this.getFile(result.data.data.logoimage)
                    } else {
                        const image = Api.getLoginImage()
                        if (image) {
                            PapiroConsole.log('image')
                            PapiroConsole.log(image)
                            this.getFile(image)
                        } else {
                            this.setState({ logoimagesrc: LogoMarca })
                        }
                    }
                } else {
                    this.setState({ loading: false })
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                PapiroConsole.log("err")
                PapiroConsole.log(err)
                if (err.response && err.response.status == 404) {
                    return
                }
                this.setState({ loading: false })
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    handleDelete(chipToDelete) {
        let valueAtual = this.state.contentFilter.split("\n")
        var newvalue = "";
        valueAtual.map(item => {
            if (item != "" && item != valueAtual[chipToDelete]) {
                newvalue = newvalue + item + " \n"
            }
        })

        this.setState({
            contentFilter: newvalue
        });

        if (newvalue == "") {
            this.clearFields()
        }

    };

    useStyles = _ => {
        return withStyles({
            ImageList: {
                width: "100%",
                height: 100,
            },
        });
    }

    getCalledFile = async (attachment) => {
        const intl = this.props.intl;
        this.setState({ loading: true });

        let url = await FileService.getFileDownloadLink(attachment.id);
        if (url && url.data && url.data.data && url.data.success) {
            this.setState({ loading: false });
            window.open(`${url.data.data}`, '_blank');
        } else {
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "file.not.found" })
            });
        }
    }

    copyFileLink = async (attachment) => {
        const intl = this.props.intl;
        this.setState({ loading: true });

        let url = await FileService.getFileDownloadLink(attachment.id);
        if (url && url.data && url.data.data && url.data.success) {
            this.setState({ loading: false });
            navigator.clipboard.writeText(url.data.data)
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "success",
                notificationMessage: "Link de download copiado!"
            })
        } else {
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "file.not.found" })
            });
        }
    }

    getFile = async (image) => {
        let xhttpImage = new XMLHttpRequest()
        xhttpImage.open("GET", `${image.anonymoustoken}`, false)
        xhttpImage.setRequestHeader('Access-Control-Allow-Origin', '*')
        try {
            xhttpImage.send()
            let ImageData = JSON.parse(xhttpImage.responseText)
            if (ImageData && ImageData.data && ImageData.data.length > 0) {
                this.setState({ logoimagesrc: ImageData.data })
            }
        }
        catch (e) {
            PapiroConsole.log("e")
            PapiroConsole.log(e)
        }
    }

    openCreateCalledDialog = (calledServiceSettingsList) => {
        this.setState({
            createCalledDialogOpen: true,
            calledServiceSettingsList: calledServiceSettingsList
        })
    }

    closeCreateCalledDialog = () => {
        this.setState({ createCalledDialogOpen: false })
    }

    render() {
        const { classes } = this.props;
        const intl = this.props.intl;
        const { clientportal, logoimagesrc, loading } = this.state

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        const classes2 = this.useStyles();

        if (loading) {
            return (
                <div>
                    <Overlay>
                        <CircularProgress color='secondary' />
                    </Overlay>
                </div>
            )
        } else {
            return (
                <div >
                    <main
                        className={classes.contentExternal}
                    >
                        <Container style={{ maxWidth: '100vw', width: '100vw', margin: 0, padding: 0, minHeight: "100vh" }}>
                            <Grid container marginTop={0} spacing={6} direction="column" justifyContent="space-between" minHeight="100vh">
                                <Grid item container style={{ paddingTop: 0 }} spacing={2}>
                                    <Header
                                        intl={this.props.intl}
                                        clientportal={clientportal}
                                        calledservicesettings={clientportal.calledservicesettingsclientportals}
                                        language={this.props.match.params.lang}
                                        openCreateCalledDialog={this.openCreateCalledDialog}
                                        logoimagesrc={logoimagesrc}
                                    />
                                    <Grid item sm={12} container >

                                        {
                                            clientportal && clientportal.mainimage ?
                                                <div id="mainimage" style={{ display: "block", width: "100vw", height: "300px", textAlign: "center", alignContent: "center" }}>
                                                    {
                                                        clientportal.enablesearch &&
                                                        <>
                                                            <h2 style={{ color: "white", marginBottom: "10px", fontWeight: "bold", fontSize: "25px" }}>
                                                                {clientportal.searchtext}
                                                            </h2>
                                                            <StyledTextField
                                                                variant="outlined"
                                                                name="searchValueBar"
                                                                className={classes.root}
                                                                label={intl.formatMessage({ id: "search" })}
                                                                value={this.state.searchValueBar}
                                                                   placeholder={intl.formatMessage({ id: "search.news.placeholder" })}
                                                                onChange={this.handleChange}
                                                                onKeyPress={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        this.searchArticle();
                                                                    }
                                                                }}
                                                                color="primary"
                                                                sx={{
                                                                    width: "600px"
                                                                }}
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton onClick={_ => this.searchArticle()}>
                                                                                <Search />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    )
                                                                }}
                                                            >
                                                            </StyledTextField>
                                                        </>
                                                    }
                                                </div>
                                                :
                                                <div style={{ display: "block", width: "101vw", height: "300px", backgroundColor: clientportal.defaultcolor, textAlign: "center", alignContent: "center" }}>
                                                    {
                                                        clientportal && clientportal.enablesearch &&
                                                        <>
                                                            <h2 style={{ color: "white", marginBottom: "10px", fontWeight: "bold", fontSize: "25px" }}>
                                                                {clientportal.searchtext}
                                                            </h2>
                                                            <StyledTextField
                                                                variant="outlined"
                                                                name="searchValueBar"
                                                                label={intl.formatMessage({ id: "search" })}
                                                                value={this.state.searchValueBar}
                                                               placeholder={intl.formatMessage({ id: "search.news.placeholder" })}
                                                                onChange={this.handleChange}
                                                                onKeyPress={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        this.searchArticle();
                                                                    }
                                                                }}
                                                                color="primary"
                                                                sx={{ width: "600px", backgroundColor: "#fff" }}
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton onClick={_ => this.searchArticle()}>
                                                                                <Search />
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    )
                                                                }}
                                                            />
                                                        </>
                                                    }
                                                </div>
                                        }
                                    </Grid>
                                    <Grid item sm={12} container marginX="20vw" style={{ maxWidth: '60vw' }} >
                                        <Grid item sm={1}>
                                            {
                                                (clientportal.defaultcolor && clientportal.defaultcolor.length > 0) ?
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={browserHistory.goBack}
                                                        sx={{
                                                            backgroundColor: clientportal.defaultcolor,
                                                            color: '#fff',
                                                            textTransform: 'none',
                                                            '&:hover': {
                                                                backgroundColor: darken(clientportal.defaultcolor, 0.2),
                                                            },
                                                        }}
                                                    >
                                                        {intl.formatMessage({ id: "back" })}
                                                    </Button>
                                                    :
                                                    <Button
                                                        variant="contained"
                                                        color="success"
                                                        onClick={browserHistory.goBack}
                                                        sx={{ textTransform: 'none' }}
                                                    >
                                                        {intl.formatMessage({ id: "back" })}
                                                    </Button>
                                            }
                                        </Grid>
                                    </Grid>
                                    {this.state.contentFilter &&
                                        <Grid item xs={12} sm={12} sx={{ marginInline: "20vw" }}>
                                            <Card  >
                                                <CardContent >
                                                    <Grid container spacing={1} alignItems="flex-end" >
                                                        <Grid item xs={8} md={6}>
                                                            <Typography variant="h5">
                                                                {intl.formatMessage({ id: "filters" })}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <strong>
                                                                {this.state.contentFilter.split("\n").map((i, key) => {
                                                                    if (i.trim() != "") {
                                                                        return <Chip
                                                                            key={key}
                                                                            label={i}
                                                                            onDelete={() => this.handleDelete(key)}
                                                                            color="primary"
                                                                            variant="outlined"
                                                                        />
                                                                    }
                                                                })}
                                                            </strong>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    }
                                    <Grid item xs={12} sm={12} sx={{ marginInline: "20vw" }}>

                                        <Card className="background-title-search">
                                            <CardContent>
                                                <Grid container spacing={2} alignItems="flex-end">
                                                    <Grid item xs={12} md={6}>
                                                        <Typography variant="h5">
                                                            {intl.formatMessage({ id: "knowledgebase" })}
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} md={5}>
                                                        <SimpleSelect label={intl.formatMessage({ id: "field" })} options={this.state.filters} stateName='filter' changeSelect={this.changeValues} selected={this.state.filterSelected} />
                                                    </Grid>
                                                    <Grid item>
                                                        <Search />
                                                    </Grid>
                                                    <Grid item >
                                                        <TextField type="text"
                                                            name="searchValue"
                                                            value={this.state.searchValue}
                                                            placeholder={intl.formatMessage({ id: "search" })}
                                                            onChange={this.onFieldChange} />
                                                        <Button
                                                            variant='contained'
                                                            color='primary'
                                                            size='large'
                                                            onClick={this.addFilter}
                                                            className={classes.button}
                                                            style={{ marginRight: 4, marginLeft: 8 }}

                                                        >
                                                            <ZoomInIcon />
                                                        </Button>

                                                        <Button
                                                            variant='contained'
                                                            color='secondary'
                                                            size='large'
                                                            className={classes.button}
                                                            style={{ marginRight: 4 }}
                                                            onClick={this.callSearch}
                                                        >
                                                            <Search />
                                                        </Button>

                                                        <Button
                                                            variant='contained'
                                                            color='primary'
                                                            size='large'
                                                            onClick={this.clearFields}
                                                            className={classes.button}

                                                        >
                                                            <ClearIcon />
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid><Grid container marginX="20vw" style={{ marginBottom: 12, marginTop: 8 }} >
                                        <Grid item xs={12} md={12}>
                                            {this.state.resultList.map(item => {
                                                return item.collapseCardItem
                                            })}
                                        </Grid>
                                    </Grid>
                                    <Grid item container marginX="20vw" style={{ marginBottom: 12, marginTop: 8 }}>
                                        <Grid item xs={12} md={3}>
                                            <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                                        </Grid>
                                        <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                                            {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Footer
                                    intl={intl}
                                    clientportal={clientportal}
                                    setLoading={loading => this.setState({ loading: loading })}
                                />
                            </Grid>

                            {loading && (
                                <Overlay>
                                    <CircularProgress color='secondary' />
                                </Overlay>
                            )}

                            <CustomizedSnackbars
                                variant={this.state.notificationVariant}
                                message={this.state.notificationMessage}
                                isOpen={this.state.openNotification}
                                toClose={this.closeNotification}
                            />
                            <Modal
                                intl={intl}
                                title={intl.formatMessage({ id: "choose.form" })}
                                open={this.state.createCalledDialogOpen}
                                onClose={this.closeCreateCalledDialog}
                                contentPadding={false}
                                children={
                                    <Box sx={{ minHeight: '50px' }}>
                                        <MyMaterialTable
                                            title=""
                                            columns={[
                                                { title: 'Id', field: 'id', width: 40 },
                                                { title: intl.formatMessage({ id: "title" }), field: 'title' },
                                                { title: intl.formatMessage({ id: "organization" }), field: 'OrganizationText' },
                                                { title: 'Rota', field: 'RouteText' },
                                            ]}
                                            rowClick={(event, rowData) => {
                                                window.open(`${rowData.RouteText}`, '_blank')
                                            }}
                                            data={this.state.calledServiceSettingsList}
                                        />
                                    </Box>
                                }
                            />
                        </Container>
                        <Dialog
                            maxWidth="md"
                            open={this.state.knowledgeBaseDetailsDialogOpen}
                            onClose={this.knowledgeBaseDetailsClose}
                            scroll={'body'}
                            aria-labelledby="knowledgebase-dialog-title">
                            <DialogTitle id="knowledgebase-dialog-title">
                                # {this.state.knowledgeBaseItem.id} | {this.state.knowledgeBaseItem.title}
                                <ClearIcon onClick={this.knowledgeBaseDetailsClose} style={{ float: 'right', cursor: 'pointer' }} />
                            </DialogTitle>
                            <DialogContent className="knowledgebase-dialog-client-details" >
                                <Grid container spacing={0} style={{ marginTop: 15 }}>
                                    <Grid item xs={12} style={{ marginBottom: 15 }}>
                                        <h5><FormattedMessage id="description" />:</h5>
                                        <div style={{ padding: '5px 10px', border: '1px solid rgba(0, 0, 0, 0.5)', borderRadius: 10 }} >{ReactHtmlParser(this.state.knowledgeBaseItem.description)}</div>
                                    </Grid>
                                    {(this.state.knowledgeBaseItem.knowledgebaseknowledgebasekeywords && this.state.knowledgeBaseItem.knowledgebaseknowledgebasekeywords.length > 0) && <Grid item xs={12} style={{ marginBottom: 15 }}>
                                        <h5><FormattedMessage id="keywords" />:</h5>
                                        <div className='kb-keys' style={{ justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                            {this.state.knowledgeBaseItem.knowledgebaseknowledgebasekeywords.map((item, key) => {
                                                return <div className='kb-key' key={key} style={{ marginTop: 15 }}>{item.knowledgebasekeyword.word}</div>
                                            })}
                                        </div>
                                    </Grid>}
                                    {this.state.knowledgeBaseItem.knowledgebaseattachments.length > 0 && (
                                        <Grid item xs={12}>
                                            <div className={classes.attachmentsBox}>
                                                <label>{<FormattedMessage id="attachments" />}</label>
                                                <ImageList cellHeight={100} className={classes2.ImageList} cols={1} >
                                                    <ul>
                                                        {this.state.knowledgeBaseItem.knowledgebaseattachments.map(file => {
                                                            return (<li key={file.attachment.id}>
                                                                <AttachFile /> <Button onClick={() => this.getCalledFile(file.attachment)}>{file.attachment.description}</Button>
                                                                <Tooltip title={<h5>Copiar link de download</h5>}>
                                                                    <IconButton aria-label="textevidence"
                                                                        onClick={() => this.copyFileLink(file.attachment)}>
                                                                        <FileCopyIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </li>)
                                                        })}
                                                    </ul>
                                                </ImageList>
                                            </div>
                                        </Grid>
                                    )}
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Grid container spacing={4} justify="flex-end" style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 15 }}>
                                    <Grid item xs={12} sm={4}>
                                        <Button
                                            variant='contained'
                                            type="button"
                                            onClick={this.knowledgeBaseDetailsClose}
                                            fullWidth
                                        >
                                            {intl.formatMessage({ id: "close" })}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </DialogActions>
                        </Dialog>
                    </main>
                </div>
            )
        }
    }
}
ExternalKnowledgeBases.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        ...componentActions,
        ...articleActions
    }, dispatch);
export default injectIntl(connect(null, mapDispatchToProps)(withStyles(Styles)(ExternalKnowledgeBases)));
ExternalKnowledgeBases.contextType = AbilityContext;
